import IAsyncArgs from "../../../shared/contracts/IAsyncArgs";
import ISourceMap from "../../../shared/contracts/ISourceMap";
import ISourceMapSaveDataBody from "../../../shared/contracts/ISourceMapSaveDataBody";
import useApi from "../../../shared/services/useApi.hook";

function useReportCoreApi() {

  const RMS_CORE_SOURCEMAP: string = 'SourceMap';
  const RMS_CORE_URL: string = `${process.env.REACT_APP_RMS_CORE_URL}`;
  const SOURCE_MAP_ID:number=0;
  const RMSCORE_TENANT_ID:number =2;

  const {
    GET, POST } = useApi();

  //GET CALLS SECTION
  const getGrossToNetList = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<ISourceMap[]>
  ): void => {

    if (doIf()) {
      GET<ISourceMap[]>(`${RMS_CORE_URL}/${RMS_CORE_SOURCEMAP}/${RMS_CORE_SOURCEMAP}/${RMSCORE_TENANT_ID}/${SOURCE_MAP_ID}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }


  const saveSourceMapDetails = (postBody: ISourceMapSaveDataBody,
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<any>
  ): void => {

    if (doIf()) {
      POST<ISourceMapSaveDataBody, any>(`${RMS_CORE_URL}/${RMS_CORE_SOURCEMAP}/${RMSCORE_TENANT_ID}`,
        postBody,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  // ---
  return {
    getGrossToNetList,
    saveSourceMapDetails
  }

}
export default useReportCoreApi;